import {
  getAppNameByAppId,
  INTEGRATIONS_APPS,
  IntegrationsAppsNames,
} from 'integrations-lib/constants/AppIds';
import { TReconnectConfig } from './types/reconnection-config';
import { EventbriteReconnectionConfig } from './integrations/Eventbrite/EventbriteReconnectionConfig';
import { TrelloReconnectionConfig } from './integrations/Trello/TrelloReconnectionConfig';
import { AIReconnectionConfig } from './integrations/AIIntegrations/AIReconnectionConfig';
import { GoogleSearchConsoleReconnectionConfig } from './integrations/GoogleSearchConsole/GoogleSearchReconnectionConfig';
import { UberconferenceReconnectionConfig } from './integrations/Uberconference/UberconferenceReconnectionConfig';

export const RECONNECTION_CONFIGS: Partial<
  Record<IntegrationsAppsNames, TReconnectConfig>
> = {
  [INTEGRATIONS_APPS.ANTHROPIC]: AIReconnectionConfig,
  [INTEGRATIONS_APPS.COHERE]: AIReconnectionConfig,
  [INTEGRATIONS_APPS.EVENTBRITE]: EventbriteReconnectionConfig,
  [INTEGRATIONS_APPS.GEMINI]: AIReconnectionConfig,
  [INTEGRATIONS_APPS.GOOGLE_SEARCH_CONSOLE]:
    GoogleSearchConsoleReconnectionConfig,
  [INTEGRATIONS_APPS.OPENAI]: AIReconnectionConfig,
  [INTEGRATIONS_APPS.TRELLO]: TrelloReconnectionConfig,
  [INTEGRATIONS_APPS.XAI]: AIReconnectionConfig,
  [INTEGRATIONS_APPS.UBER_CONFERENCE]: UberconferenceReconnectionConfig,
};

export const getReconnectionConfigByAppId = (appId: number) => {
  const appName = getAppNameByAppId(appId);

  return RECONNECTION_CONFIGS[appName] || null;
};
